/* globals Knitiv */

export default class KformContentController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor($location, $rootScope, $scope, $timeout) {
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		/** @type {boolean} */
		this.kds = $rootScope.kds;

		/** @type {?import('../kform.controller').default} */
		this.kform = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {any} */
		this.options = undefined;

		/** @type {boolean} */
		this.resizing = false;

		/** @type {boolean} */
		this.showWorkflow = false;

		/** @type {string | undefined} */
		this.tab = undefined;
	}

	/**
	 * @param {string} search
	 * @param {string} parameterValue
	 */
	locationSearch(search, parameterValue) {
		if (search === 'tab' && parameterValue === undefined) {
			// eslint-disable-next-line no-param-reassign
			parameterValue = this.form?.params.defaultTab || this.options?.tab;
		}

		if (parameterValue && (this.$location.path().startsWith('/form') || this.$location.path().startsWith('/list'))) {
			this.$location.search(search, parameterValue);
		}
	}

	refreshTabFile() {
		if (this.form?.viewer_engine === 'pdf') {
			this.$scope.$broadcast('Form.change-tab');
		}
	}

	refreshTabForm() {
		this.$scope.$broadcast('Form.ktable-redraw');
	}

	startResizing() {
		if (!this.resizing) {
			this.resizing = true;
			this.$scope.$apply();
		}
	}

	stopResizing() {
		if (this.resizing) {
			this.resizing = false;
			this.$timeout(() => {
				this.resizing = false;
			}, 100);
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.kid && this.kform?.forms && this.kid && this.kid in this.kform.forms) {
			this.form = this.kform.forms[this.kid];
		}
	}

	$onDestroy() {
		this.form?.removeEvents();
	}

	$onInit() {
		if (!this.kform?.options?.modal) {
			this.$scope.$on('angular-resizable.resizing', () => this.startResizing());

			this.$scope.$on('angular-resizable.resizeEnd', () => this.stopResizing());

			this.$scope.$on('List.resizing', () => this.startResizing());

			this.$scope.$on('List.resizeEnd', () => this.stopResizing());

			this.$scope.$watch('$ctrl.form.tab', () => {
				if (this.form?.tab) {
					this.tab = this.form.tab;
					this.locationSearch('tab', this.form.tab);
				}
			});

			this.$scope.$on('$routeUpdate', (/** @type {Event} */ $event, /** @type {any} */ next) => {
				if (next.params?.tab) {
					this.tab = next.params.tab;
					if (this.form && this.tab) {
						this.form.tab = this.tab;
					}
				}
			});
		}
	}
}
